import { render } from "./ToolbarComp.vue?vue&type=template&id=04451286&scoped=true"
import script from "./ToolbarComp.vue?vue&type=script&lang=js"
export * from "./ToolbarComp.vue?vue&type=script&lang=js"

import "./ToolbarComp.vue?vue&type=style&index=0&id=04451286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04451286"]])

export default __exports__